export default __webpack_public_path__ + "static/media/computer.1ad27275.svg";